// app/ClientApp.jsx
'use client';

import { themeConfig, ThemeProvider } from 'src/theme';
import { APIProvider } from '@vis.gl/react-google-maps';
import ReactQueryProvider from 'src/components/providers/react-query-provider';
import { I18nProvider } from 'src/locales/i18n-provider';
import { LocalizationProvider } from 'src/locales';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { Snackbar } from 'src/components/snackbar';
import { ProgressBar } from 'src/components/progress-bar';
import { defaultSettings, SettingsDrawer, SettingsProvider } from 'src/components/settings';
import { InitColorSchemeScript } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import { CONFIG } from 'src/global-config';
import { themeOverrides } from 'src/theme/theme-overrides';
import i18next from 'i18next';
import { ZohoSalesIQ } from 'src/utils/zoho-sales-IQ';
import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';

export default function ClientApp({ children }) {
  const getLanguage = () => i18next.language || 'ar';
  useEffect(() => {
    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_ENV === 'qa') {
      Clarity.init(process.env.NEXT_PUBLIC_CLARITY_QA_PROJECT_ID);
    }
    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_ENV === 'prod') {
      Clarity.init(process.env.NEXT_PUBLIC_CLARITY_PROD_PROJECT_ID);
    }
  }, []);
  return (
    <>
      <InitColorSchemeScript
        attribute={themeConfig.cssVariables.colorSchemeSelector}
        modeStorageKey={themeConfig.modeStorageKey}
        defaultMode={themeConfig.defaultMode}
      />

      <APIProvider
        apiKey={CONFIG.apiKey}
        libraries={['places']}
        region="SA"
        language={getLanguage()}
      >
        <ReactQueryProvider>
          <I18nProvider>
            <SettingsProvider defaultSettings={defaultSettings}>
              <LocalizationProvider>
                <AppRouterCacheProvider options={{ key: 'css' }}>
                  <ThemeProvider
                    themeOverrides={themeOverrides}
                    modeStorageKey={themeConfig.modeStorageKey}
                    defaultMode={themeConfig.defaultMode}
                  >
                    <MotionLazy>
                      <Snackbar />
                      <ZohoSalesIQ />
                      <ProgressBar />
                      <SettingsDrawer defaultSettings={defaultSettings} />
                      {children}
                    </MotionLazy>
                  </ThemeProvider>
                </AppRouterCacheProvider>
              </LocalizationProvider>
            </SettingsProvider>
          </I18nProvider>
        </ReactQueryProvider>
      </APIProvider>
    </>
  );
}
